<template>
  <v-app id="inspire">
    <v-app-bar app color="white" :elevation="1">
      <img
        src="@/assets/logo-heig-vd.png"
        alt="Logo HEIG-VD"
        height="100%"
        class="logo"
      />
      <div class="d-flex align-center ml-10">Bons de commande</div>
      <v-btn text to="/orders" :ripple="false" active-class="none">Mes bons de commande</v-btn>
      <v-btn text to="/validations" :ripple="false">Validations</v-btn>
      <v-spacer></v-spacer>
      <v-btn
        text
        @click="
          $route.path !== '/orders/create'
            ? $router.push('/orders/create')
            : null
        "
        >Nouveau bon de commande</v-btn
      >
      <user-profile />
    </v-app-bar>

    <v-main class="grey lighten-3">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import UserProfile from "@/components/UserProfile";

export default {
  components: {
    UserProfile,
  },
};
</script>

<style>
.logo {
  position: fixed;
  left: 0;
}
.v-btn--active::before {
  opacity: 0 !important;
}
</style>